import debounce from "@mui/material/utils/debounce";
import { useEffect, useMemo, useState } from "react";

/**
 * Return the value once it has stopped changing for the given delay.
 * The first render returns the value at once, so a query keyed by it starts without waiting.
 */
export const useDebouncedValue = <T,>(value: T, delayMs: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const debouncedSet = useMemo(() => debounce(setDebouncedValue, delayMs), [delayMs]);

  useEffect(() => {
    debouncedSet(value);
    // Drops the pending update on the next change and on unmount
    return debouncedSet.clear;
  }, [debouncedSet, value]);

  return debouncedValue;
};
